document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-mobile-toggle]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const nav=document.querySelector('[data-mobile-nav]');
      if(!nav) return;
      nav.hidden=!nav.hidden;
      btn.setAttribute('aria-expanded', nav.hidden ? 'false' : 'true');
    });
  });
});
